import { QueryString } from "../common/helper";
import FileService from "./FileService";
import { Request } from "./HttpService";

function serializeObject(searchObject) {
  let keys = Object.keys(searchObject);
  let serialized = "";
  for (let key of keys) {
    if (key === "startingDate" || key === "endingDate") {
      if (searchObject[key])
        serialized = serialized + `${key}=${searchObject[key].toUTCString()}&`;
    } else if (key === "businessAreas") {
      if (searchObject[key].length > 0)
        serialized =
          serialized +
          searchObject[key].map((item) => key + "=" + item).join("&") +
          "&";
    } else serialized = serialized + `${key}=${searchObject[key]}&`;
  }
  return serialized;
}

export const PreCandidateService = {
  GetPrecandidatesPaginated: function (pageNumber, pageSize, searchObject) {
    let url = `vitae/precandidate/${pageSize}/${pageNumber}`;
    let keys = Object.keys(searchObject);
    if (keys.length > 0) {
      url = url + "?";
      QueryString.saveJsonObject(searchObject, "searchObject");
      url = url + serializeObject(searchObject);
    }

    return Request(url, "GET");
  },

  GetAvailabilityStatus: function () {
    return Request(
      "vitae/precandidate/GetPrecandidateAvailabilityStatus/",
      "GET"
    );
  },
  getContactAvailabilityStatus() {
    return Request("vitae/precandidate/getContactAvailabilityStatus");
  },

  getPrecandidateManagers: function () {
    return Request("userAccess/User/precandidate/Managers/", "GET");
  },

  GetInactiveManagerList: function () {
    return Request("userAccess/User/precandidate/inactiveManagers/", "GET");
  },

  GetUserById: function (id) {
    return Request(`vitae/User/${id}`, "GET");
  },

  EditPrecandidate: function (item, errorCalback) {
    return Request(`vitae/Precandidate/${item.id}`, "PUT", item, errorCalback);
  },

  GetPreCandidateHistory: function (preCandidateId) {
    return Request(
      "vitae/Precandidate/GetHistory?preCandidateId=" + preCandidateId,
      "GET"
    );
  },

  CreatePrecandidate: function (precandidate, errorCalback) {
    return Request("vitae/Precandidate", "POST", precandidate, errorCalback);
  },

  GetPrecandidateById: function (id) {
    return Request(`vitae/Precandidate/${id}`, "GET");
  },

  GetAllPrecandidates: function () {
    return Request(`vitae/Precandidate/1/1`, "GET");
  },

  DeletePrecandidate: function (id) {
    return Request(`vitae/Precandidate/${id}`, "DELETE");
  },

  GetReasons: function () {
    return Request("vitae/AvailabilityReason/", "GET");
  },

  CreateCandidateInteraction: function (item) {
    return Request("vitae/CandidateInteractions", "POST", item);
  },

  CreateInterviewOrScreenCall: function (preCandidateId, isInterview) {
    if (isInterview)
      return Request(
        "vitae/Precandidate/CreateInterview",
        "POST",
        preCandidateId
      );
    else
      return Request(
        "vitae/Precandidate/CreateScreenCall",
        "POST",
        preCandidateId
      );
  },

  GetAlertMessageToCreateInterview: function (preCandidateId) {
    return Request(
      `vitae/Precandidate/GetAlertMessageToCreateInterview/${preCandidateId}`,
      "GET"
    );
  },

  exportToexcel(pageSize, pageNumber, filename, format, searchObject) {
    let url = `vitae/Precandidate/${pageSize}/${pageNumber}/${format}/export?${serializeObject(
      searchObject
    )}`;
    FileService.Download(url, filename);
  },

  SendDNA: function (params) {
    return Request("vitae/Precandidate/SendDNA", "POST", params);
  },

  GetDocOnlineTemplate: function (preCandidateId, fileNameDownload, format) {
    let url = `vitae/Precandidate/download/${format}/${preCandidateId}`;
    return FileService.Download(url, fileNameDownload);
  }
};
